import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.3/js/sparta-events-utility";
import spartaSingletonUtility from "utilities/global/sparta-singleton-utility/1.0.0/js/sparta-singleton-utility";
import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.7.1/js/sparta-ui-layers-utility";
import spartaAccordionUtility from "utilities/global/sparta-accordion-utility/8.4.0/js/sparta-accordion-utility";
import spartaStickyUtility from "utilities/global/sparta-sticky-utility/4.0.4/js/sparta-sticky-utility";
/**
 * Utility recalculate-sticky-utility
 * @description Calls spartaStickyUtility.recalcStickyEls to recalculate sticky's
 * fade out position after DOM changes
 * @author zkymyru
 * @copyright 2018-2-6
 */

const EVENTS = {
  SPARTA_GLOBAL_READY: 'SPARTA_GLOBAL_READY.spartaBootstrapUtility',
};

/**
 * @class RecalculateStickyUtility
 * @export
 */
class RecalculateStickyUtility {
  /**
   * Creates instance of RecalculateStickyUtility
   */
  constructor() {
    this.init();
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @returns {undefined}
   */
  init() {
    spartaEventsUtility.sub(EVENTS.SPARTA_GLOBAL_READY, () => {
      const titleModule = document.getElementById('titleModule');
      const titleSticky = titleModule ? titleModule.querySelector('.spa-sticky') : null;

      if (titleSticky) {
        this.recalculateStickiesOnDomChange();
        this.recalculateStickiesOnMenuClick();
        this.recalculateStickiesOnAccordionClick();
        this.recalculateStickiesOnModalClosed();
      }
    });
  }

  /**
   * Recalculates stickies after DOM changes
   * Observer runs only once after page load
   * @return {underfined} underfined
   */
  recalculateStickiesOnDomChange() {
    const observer = new MutationObserver(() => {
      spartaStickyUtility.recalcStickyEls();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  /**
   * Recalculates stickies after opening or closing top Menu
   * This needed as mutationObserver doesn't detect when elements
   * get updated from hidden to visible
   * @return {underfined} underfined
   */
  recalculateStickiesOnMenuClick() {
    const topMenu = document.getElementById('ancShowHideRelatedLinks');
    if (topMenu) {
      topMenu.addEventListener('click', () => {
        setTimeout(() => {
          spartaStickyUtility.recalcStickyEls();
        }, 500);
      });
    }
  }

  /**
   * Recalculates stickies after opening or closing an accordion.
   * @return {underfined} underfined
   */
  recalculateStickiesOnAccordionClick() {
    [
      spartaAccordionUtility.EVENTS.ACCORDION_ITEM_HIDE,
      spartaAccordionUtility.EVENTS.ACCORDION_ITEM_SHOW,
      spartaAccordionUtility.EVENTS.ACCORDION_SHOW_ALL,
      spartaAccordionUtility.EVENTS.ACCORDION_HIDE_ALL,
    ].forEach((event) => {
      spartaEventsUtility.sub(event, () => {
        setTimeout(() => {
          spartaStickyUtility.recalcStickyEls();
        }, 1e3);
      });
    });
  }

  /**
   * Needed for sticky to be in proper position. Covering global nav.
   * Fix for when scrolled down prior to ui layers opening.
   * @return {underfined} underfined
   */
  recalculateStickiesOnModalClosed() {
    spartaEventsUtility.sub(spartaUILayersUtility.EVENTS.MODAL_CLOSED, () => {
      setTimeout(() => {
        spartaStickyUtility.recalcStickyEls();
      }, 250);
    });
  }
}

/**
 * @const RecalculateStickyUtility
 * @description single instance of RecalculateStickyUtility used to expose this utility
 */

export default spartaSingletonUtility(
  'sparta.utility.RecalculateStickyUtility',
  RecalculateStickyUtility,
);
